import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const store = {
  state() {
    return {
      settings: {
        collapsedSidebar: false,
        // State for pagination. Can be either 15, 25 or 50
        itemsPerPage: 15,
      },
    }
  },
  actions,
  mutations,
  getters,
}

export default store

export * from './actionTypes'
export * from './mutationTypes'
